import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import config from 'config';

import CustomerJourneyDataMock from './data/CustomerJourneyDataMock';

// This sets the mock adapter on the default instance
var apiMock = new MockAdapter(axios, { delayResponse: 1000 });

const baseUrl = config.apiBaseUrl;

/* CustomerJourney Apis */

/* Hotel */
apiMock.onGet(/^.+\/hotel/).reply((config) => {

    console.log("Serving hotel api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.hotel];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Reservation */
apiMock.onGet(/^.+\/reservation/).reply((config) => {

    console.log("Serving reservation api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.reservation];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Categories */
apiMock.onGet(/^.+\/categories/).reply((config) => {

    console.log("Serving categories api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.categories];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Event Categories */
apiMock.onGet(/^.+\/eventsCategories/).reply((config) => {

    console.log("Serving event categories api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.eventCategories];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Events */
let eventsDataToggler = true;
apiMock.onGet(/^.+\/events/).reply((config) => {

    console.log("Serving events api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");
    var catId = url.searchParams.get("cat_id");

    let array_1 = CustomerJourneyDataMock.eventCategory.slice(0, 2);
    let array_2 = CustomerJourneyDataMock.eventCategory.slice(2, 10);

    let selectedArray = eventsDataToggler ? array_1: array_2;
    eventsDataToggler = !eventsDataToggler;

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, selectedArray];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Attractions */
apiMock.onGet(/^.+\/attractions/).reply((config) => {

    console.log("Serving attractions api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.attractions];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Menu */
apiMock.onGet(/^.+\/menu/).reply((config) => {

    console.log("Serving menu api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.menu];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Venues */
apiMock.onGet(/^.+\/venues/).reply((config) => {

    console.log("Serving venues api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.venues];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Services */
let servicesDataToggler = true;
apiMock.onGet(/^.+\/services/).reply((config) => {

    console.log("Serving services api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");
    var catId = url.searchParams.get("cat_id");

    let array_1 = CustomerJourneyDataMock.services.slice(0, 2);
    let array_2 = CustomerJourneyDataMock.services.slice(2, 9);

    let selectedArray = servicesDataToggler ? array_1: array_2;
    servicesDataToggler = !servicesDataToggler;

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, selectedArray];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Services Book */
let servicesBookDataToggler = 0;
apiMock.onPut(/^.+\/services/).reply((config) => {

    console.log("Serving service book api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    const requestData = JSON.parse(config.data);
    let responseData = {};

    switch (servicesBookDataToggler % 3) {
        case 0:
            servicesBookDataToggler++;
            responseData[requestData.service_id] = 'booked';
            break;
        case 1:
            servicesBookDataToggler++;
            responseData[requestData.service_id] = 'wait_response';
            break;
        case 2:
            servicesBookDataToggler++;
            return [400];
            break;
    }

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, responseData];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [400];
    }
});

apiMock.onPost(/^.+\/login/).reply((config) => {

    console.log("Serving login api call.");

    const {reservation_id, surname} = JSON.parse(config.data);

    if(reservation_id == "1234" && surname == "abcd") {
        return [201, {token: "ab123cd"}];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

apiMock.onPost(/^.+\/reservation/).reply((config) => {

    console.log("Serving login api call.");

debugger

    const {checkin, checkout, surname} = JSON.parse(config.data);

    if(checkin == "2019-01-01" && checkout == "2019-01-02" && surname == "abcd") {
        return [201, {token: "ab123cd"}];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Weather */
apiMock.onGet(/^.+\/weather/).reply((config) => {

    console.log("Serving weather api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.weather];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* Mail Subscribe/Unsubscribe */
apiMock.onPut(/^.+\/unsubscribe/).reply((config) => {

    console.log("Serving Subscribe api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd') {
        return [200];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

apiMock.onDelete(/^.+\/unsubscribe/).reply((config) => {

    console.log("Serving Unsubscribe api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd') {
        return [200];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* News Categories */
apiMock.onGet(/^.+\/newsCategories/).reply((config) => {

    console.log("Serving news categories api call.");

    var url = new URL(config.url);
    var token = url.searchParams.get("token");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [200, CustomerJourneyDataMock.newsCategories];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});

/* News */
apiMock.onGet(/^.+\/news/).reply((config, params) => {

    console.log("Serving news api call.");

    const url = new URL(config.url);
    const token = url.searchParams.get("token");
    const catId = url.searchParams.get("cat_id");

    if(token === 'ab123cd' || token === 'hotel_id') {
        return [
            200,
            CustomerJourneyDataMock.newsCategory
        ];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    }
    else {
        return [401];
    }
});



/* News Categories */
apiMock.onGet(/^.+\/newsCategories/).reply((config) => {

  console.log("Serving news categories api call.");

  var url = new URL(config.url);
  var token = url.searchParams.get("token");

  if(token === 'ab123cd' || token === 'hotel_id') {
    return [200, CustomerJourneyDataMock.newsCategories];
  }
  else if(token === 'deactivated') {
    return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
  }
  else {
    return [401];
  }
});

/* News */
apiMock.onGet(/^.+\/news/).reply((config, params) => {

  console.log("Serving news api call.");

  const url = new URL(config.url);
  const token = url.searchParams.get("token");
  const catId = url.searchParams.get("cat_id");

  if(token === 'ab123cd' || token === 'hotel_id') {
    return [
      200,
      CustomerJourneyDataMock.newsCategory
    ];
  }
  else if(token === 'deactivated') {
    return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
  }
  else {
    return [401];
  }
});

/* Survey */
apiMock.onGet(/^.+\/duringStaySurvey/)
  .reply((config) => {

    console.log('Serving get duringStaySurvey answer api call.');

    var url = new URL(config.url);
    var token = url.searchParams.get('token');

    if (token === 'ab123cd') {
      return [200, CustomerJourneyDataMock.duringStaySurvey_getAnswer];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    } 
    else {
      return [401];
    }
  });

apiMock.onPut(/^.+\/duringStaySurvey/)
  .reply((config) => {

    console.log('Serving get duringStaySurvey answer api call.');

    var url = new URL(config.url);
    var token = url.searchParams.get('token');

    if (token === 'ab123cd') {
      return [200, CustomerJourneyDataMock.duringStaySurvey_sendAnswer];
    }
    else if(token === 'deactivated') {
        return [400, "Cannot execute hotel request. Property doesn't have the CJ Or Cj Website enabled"]
    } 
    else {
      return [401];
    }
  });

export default apiMock;



// WEBPACK FOOTER //
// ./sources/mocks/ApiMock.js